import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

interface ToolStatusLineProps {
  label: string;
}

const ToolStatusLine: React.FC<ToolStatusLineProps> = ({ label }) => (
  <div style={{ color: '#8c8c8c', fontStyle: 'italic', margin: '4px 0' }}>
    <LoadingOutlined style={{ marginRight: 6 }} />
    {label}…
  </div>
);

export default ToolStatusLine;
